import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

export function NoteDialog({ open, onOpenChange, book, ch, verse, refText, note, onSaved }: { open: boolean; onOpenChange: (o: boolean) => void; book: number; ch: number; verse: number; refText: string; note: string; onSaved: (n: string) => void }) {
  const [text, setText] = useState(note);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setText(note); }, [open, note]);
  const save = async (value: string) => {
    setBusy(true);
    try {
      const { data } = await api.put("/deep/marks/note", { book, ch, verse, note: value });
      onSaved(data.note); onOpenChange(false);
      toast.success(data.note ? "Note saved" : "Note removed");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="note-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl">My note</DialogTitle>
          <DialogDescription>{refText} · only you can see this</DialogDescription>
        </DialogHeader>
        <Textarea data-testid="note-input" value={text} maxLength={1000} onChange={(e) => setText(e.target.value)} placeholder="What is this verse saying to you?" className="min-h-[140px] font-scripture text-lg" autoFocus />
        <div className="flex justify-between gap-2">
          {note ? <Button data-testid="note-delete" variant="ghost" disabled={busy} onClick={() => save("")} className="rounded-full text-red-700">Remove note</Button> : <span />}
          <Button data-testid="note-save" disabled={busy || !text.trim()} onClick={() => save(text)} className="rounded-full bg-[#1E293B]">Save note</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
